// extracted by mini-css-extract-plugin
module.exports = {"neonHeadCont":"NeonText_neonHeadCont__3AzcV","neonHeadImg":"NeonText_neonHeadImg__2Zc0Z"};